// react_frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MotherProvider } from './Context/MotherContext';

// ------------------ ResizeObserver warning fix ------------------
const suppressResizeObserverWarnings = (e) => {
  if (
    e.message &&
    (e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
      e.message.includes('ResizeObserver loop limit exceeded'))
  ) {
    // Stop error showing up in Chrome
    e.stopImmediatePropagation();
  }
};

// Chrome-style errors
window.addEventListener('error', suppressResizeObserverWarnings);
window.addEventListener('unhandledrejection', suppressResizeObserverWarnings);

// Firefox + Webpack overlay fix (override console.error in dev only)
if (process.env.NODE_ENV === 'development') {
  const origConsoleError = console.error;
  console.error = (...args) => {
    if (
      args.length &&
      typeof args[0] === 'string' &&
      (args[0].includes('ResizeObserver loop completed with undelivered notifications') ||
        args[0].includes('ResizeObserver loop limit exceeded'))
    ) {
      return; // swallow only this warning so overlay doesn't trigger
    }
    origConsoleError(...args);
  };
}
// ----------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MotherProvider>
    <App />
  </MotherProvider>
);

reportWebVitals();
